import { IconProps } from '../icon';
import svg from './row-svg/doc-pas-integre.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DocPasIntegreIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default DocPasIntegreIcon;
